export const SITE_URL = 'https://theotherlab.co';
export const SITE_NAME = 'The Other Lab';
export const SITE_DESCRIPTION = 'An independent digital creative agency catalysing design and rebranding experiences.';
export const CONTACT_EMAIL = 'hello@theotherlab.co';
export const GTM_ID = 'GTM-TCHKWZSJ';
export const MOBILE_MAX_WIDTH = 767;
